// extracted by mini-css-extract-plugin
module.exports = {"click":"SpanEdit_click_1BQDO","edit":"SpanEdit_edit_ZV4OZ"};